module.exports = __webpack_public_path__ + "static/media/IMG_6957.299b58e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/vertical/IMG_6957.jpg
// module id = 113
// module chunks = 0